module.exports = __webpack_public_path__ + "img/sugarstick.6fc50201.jpeg";